import { EcommerceItem, EcommerceStep, ReservationContext } from '../types'
import { hasConsent } from './consent'

// Re-checks live analytics consent on every call (not just once at gtag.js
// init time) so a later withdrawal takes effect starting with the very next
// tracked event, mirroring facebookPixel.ts's trackFacebookPageView. Wrapped
// in try/catch so a consent-check failure fails safe to "not consented"
// (FR-010) rather than ever risking a call slipping through.
const gtag = (...args: unknown[]): void => {
  try {
    if (
      typeof window !== 'undefined' &&
      typeof window.gtag === 'function' &&
      hasConsent('analytics')
    ) {
      window.gtag(...args)
    }
  } catch {
    // Fail safe: never send tracking data when consent status can't be confirmed.
  }
}

export const trackPageView = (path: string): void => {
  gtag('event', 'page_view', { page_path: path })
}

export const trackEvent = (
  category: string,
  action: string,
  label?: string | null,
  reservation?: ReservationContext
): void => {
  gtag('event', action, {
    event_category: category,
    event_label: label,
    ...(reservation ? { reservation } : {}),
  })
}

export const trackLogin = (): void => {
  gtag('event', 'login')
}

export const trackEcommerceEvent = (
  step: EcommerceStep,
  items: EcommerceItem[]
): void => {
  gtag('event', step, {
    items,
  })
}
